import script from "./IdCardsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./IdCardsView.vue?vue&type=script&setup=true&lang=ts"

import "./IdCardsView.vue?vue&type=style&index=0&id=7e294a8f&scoped=true&lang=less"

import exportComponent from "/Users/jeff/projects/js/pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e294a8f"]])

export default __exports__